import { UseMutationOptions } from 'react-query';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import MutationKeys from './keys';
import { CommunicationType } from 'domains/content/types';

export type UpdateWhatsAppInput = {
    applicationsAccess?: string;
    name: string;
    language: string;
    components: any;
    communicationType?: CommunicationType;
    status?: string;
    whatsappAccountId?: string;
    whatsappNamespace?: string;
    whatsappTemplateId?: string;
};

const useUpdateWhatsApp = (
    whatsAppTemplateId: string,
    mutateOptions: UseMutationOptions<unknown, Error, UpdateWhatsAppInput>
) =>
    useMutation<UpdateWhatsAppInput>(
        MutationKeys.UPDATE_WHATSAPP_TEMPLATE,
        new PathWithID(CuredApiPaths.WHATSAPP_TEMPLATES, Number(whatsAppTemplateId)),
        mutateOptions,
        ApiMethods.PUT
    );

export default useUpdateWhatsApp;
